import moment from 'moment'
import type { Moment } from 'moment'


export const RANGE_OVERRIDE_START = 'periodStartDate'
export const RANGE_OVERRIDE_END = 'periodEndDate'

const INPUT_DATE_FORMAT = 'YYYY-MM-DD'

export type RangeOverrideResult = {
  data: any
  startTime: Moment | null
  endTime: Moment | null
}

const parseStart = (value: unknown): Moment | null => {
  if (typeof value !== 'string' || value === '') return null
  const parsed = moment(value, INPUT_DATE_FORMAT, true)
  return parsed.isValid() ? parsed.startOf('day') : null
}

const parseEnd = (value: unknown): Moment | null => {
  const parsed = parseStart(value)
  return parsed ? parsed.hour(23).minute(59).second(0).millisecond(0) : null
}

export const toInputDate = (date?: {
  year: number | null
  month: number | null
  day: number | null
} | null): string => {
  if (date?.year == null || date?.month == null || date?.day == null) return ''
  return moment({
    year: date.year,
    month: date.month - 1,
    day: date.day,
  }).format(INPUT_DATE_FORMAT)
}


export const takeRangeOverride = (data: any): RangeOverrideResult => {
  if (!data || typeof data !== 'object') {
    return { data, startTime: null, endTime: null }
  }

  const {
    [RANGE_OVERRIDE_START]: rawStart,
    [RANGE_OVERRIDE_END]: rawEnd,
    ...rest
  } = data

  if (rest.period === true) {
    return { data: rest, startTime: null, endTime: null }
  }

  const startTime = parseStart(rawStart)
  const endTime = parseEnd(rawEnd)
  const usable = startTime != null && endTime != null && !startTime.isAfter(endTime)

  return {
    data: rest,
    startTime: usable ? startTime : null,
    endTime: usable ? endTime : null,
  }
}
